import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    class: "mx-auto w-full max-w-[1600px] px-6 pb-14 pt-8 lg:px-10",
    "data-testid": "home-view"
};
const _hoisted_2 = { class: "flex flex-col gap-5" };
const _hoisted_3 = { class: "flex flex-col gap-3" };
const _hoisted_4 = {
    "data-testid": "home-greeting",
    class: "text-[1.75rem] font-bold leading-[34px] text-(--colors-text-heading)"
};
const _hoisted_5 = { class: "text-lg font-normal leading-6 text-(--colors-text-heading)" };
const _hoisted_6 = { class: "grid grid-cols-1 gap-5 lg:grid-cols-2" };
const _hoisted_7 = ["data-testid"];
const _hoisted_8 = { class: "flex flex-col gap-1.5" };
const _hoisted_9 = { class: "text-[1.375rem] font-bold leading-6.5 text-(--colors-text-heading)" };
const _hoisted_10 = { class: "text-sm font-normal leading-5 text-(--colors-text-body)" };
const _hoisted_11 = {
    key: 0,
    class: "flex flex-col gap-3"
};
const _hoisted_12 = { class: "text-[1.375rem] font-bold leading-6.5 text-(--colors-text-heading)" };
const _hoisted_13 = ["title"];
import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { Button, IconShape, WidgetShell } from "@eudonet/opal";
import { keycloakAuthService } from "@/infrastructure/adapters/KeycloakAuthService";
import { configService } from "@/infrastructure/services/ConfigService";
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeView',
    setup(__props) {
        const router = useRouter();
        const { t } = useI18n();
        const orbitalEnabled = configService.isOrbitalEnabled;
        // Greeting name straight from the Keycloak token (no backend call).
        const userInfo = keycloakAuthService.getUserInfo();
        const firstName = ref(userInfo?.given_name || userInfo?.name?.split(" ")[0] || "");
        const greeting = computed(() => firstName.value ? t("home.greeting", { name: firstName.value }) : t("home.greetingGeneric"));
        const cards = [
            { key: "donors", icon: "ri-contacts-book-line", path: "/contacts" },
            { key: "organisations", icon: "ri-building-line", path: "/organisations" },
            { key: "donations", icon: "ri-hand-heart-line", path: "/donations" },
            { key: "campaigns", icon: "ri-megaphone-line", path: "/communication" },
        ];
        function goTo(path) {
            router.push(path);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("header", _hoisted_3, [
                        _createElementVNode("h1", _hoisted_4, _toDisplayString(greeting.value), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("home.subtitle")), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cards, (card) => {
                            return _createVNode(_unref(WidgetShell), {
                                key: card.key,
                                stretch: ""
                            }, {
                                footer: _withCtx(() => [
                                    _createVNode(_unref(Button), {
                                        variant: "secondary",
                                        size: "sm",
                                        "data-testid": `home-card-cta-${card.key}`,
                                        label: _unref(t)(`home.cards.${card.key}.cta`),
                                        "icon-right": "ri-arrow-right-line",
                                        onClick: ($event) => (goTo(card.path))
                                    }, null, 8 /* PROPS */, ["data-testid", "label", "onClick"])
                                ]),
                                default: _withCtx(() => [
                                    _createElementVNode("div", {
                                        class: "flex flex-col gap-5",
                                        "data-testid": `home-card-${card.key}`
                                    }, [
                                        _createVNode(_unref(IconShape), {
                                            size: "md",
                                            color: "violet",
                                            variant: "outlined",
                                            icon: card.icon
                                        }, null, 8 /* PROPS */, ["icon"]),
                                        _createElementVNode("div", _hoisted_8, [
                                            _createElementVNode("h2", _hoisted_9, _toDisplayString(_unref(t)(`home.cards.${card.key}.title`)), 1 /* TEXT */),
                                            _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)(`home.cards.${card.key}.description`)), 1 /* TEXT */)
                                        ])
                                    ], 8 /* PROPS */, _hoisted_7)
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */);
                        }), 64 /* STABLE_FRAGMENT */))
                    ]),
                    (_unref(orbitalEnabled))
                        ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
                            _createElementVNode("h2", _hoisted_12, _toDisplayString(_unref(t)("home.dashboard.title")), 1 /* TEXT */),
                            _createElementVNode("iframe", {
                                title: _unref(t)('home.dashboard.iframeTitle'),
                                src: "https://eudonet.getorbital.ai/embed/da/lfw3Rvjqf0jFjVQvXNpiKXchpR4SzqpoAm5vmKuZpIA",
                                class: "h-[600px] w-full rounded-lg border-0",
                                allowfullscreen: ""
                            }, null, 8 /* PROPS */, _hoisted_13)
                        ]))
                        : _createCommentVNode("v-if", true)
                ])
            ]));
        };
    }
});
